import Head from "next/head";
import config from "utils/config";

const PrivacySEO: React.FC = () => {
  return (
    <Head>
      <title>Privacy comes first at Topmate</title>
      <meta
        name="description"
        content="Join 1000s of creators and experts doing more with their time"
      />
      <meta property="og:title" content="Privacy comes first at Topmate" />
      <meta
        property="og:description"
        content="Join 1000s of creators and experts doing more with their time"
      />
      <meta
        property="og:image"
        content={`${config.BASE_URL}meta-referal-image.png`}
      />
      <meta
        property="twitter:image"
        content={`${config.BASE_URL}meta-referal-image.png`}
      />
      <meta
        property="og:image:secure_url"
        content={`${config.BASE_URL}meta-referal-image.png`}
      />
    </Head>
  );
};

export default PrivacySEO;
